import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import planReducer from './slices/plan';
// slices
import listingsReducers from './slices/listing';
import managementReducers from './slices/management';
import subscriptionReducer from './slices/subscription';
import notificationReducers from './slices/notification';
import bulkCrossListReducers from './slices/bulk-cross-list';
import templateReducers from './slices/template';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};


const appReducer = combineReducers({
  listings: listingsReducers,
  management: managementReducers,
  notifications: notificationReducers,
  bulkCrossList: bulkCrossListReducers,
  subscription: subscriptionReducer,
  plan: planReducer,
  templates: templateReducers,
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    storage.removeItem('persist:root')
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export { rootReducer, rootPersistConfig };
